import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const announcementsSelector = (state: AppState) => state.announcements.data;
export const useAnnouncementsSelector = () => useSelector(announcementsSelector);
